import React, { useState, lazy } from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { ArtifactCard } from '../shared/ArtifactCard';
import { motion } from 'framer-motion';
const PRODUCTOS_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/mm8DHXzU7JhvCgYay4N1kmyc5Q2WN4pg9GNtp0heMg7BSrM3QpCC0xGOYBCXzy5-GOp2Z8fowqxSWnS4ldgA120xXC67zpfx2qL_wjuAepxGwDo6ErItRpus49bMEA7U.jpg?v=1778629864';
export function Productos() {
  const [selectedAddOns, setSelectedAddOns] = useState<string[]>([]);
  const [isBundle, setIsBundle] = useState(false);
  const coreProduct = {
    title: 'Núcleo del Arquetipo',
    price: 9.99
  };
  const addOns = [{
    id: 'sombrio',
    title: 'Archivo Sombrío',
    description: 'Explora los patrones ocultos, heridas simbólicas y reacciones internas que tu signo suele esconder.',
    price: 9
  }, {
    id: 'compatibilidad',
    title: 'Códice de Compatibilidad',
    description: 'Descubre cómo se relaciona tu arquetipo con otras energías: atracción, tensión, choque y magnetismo.',
    price: 10
  }, {
    id: 'ritual',
    title: 'Ritual del Eclipse',
    description: 'Un ritual simbólico de conexión con la energía de tu signo para integrar su fuerza de forma consciente.',
    price: 8
  }, {
    id: 'camara',
    title: 'Cámara Astral',
    description: 'Una experiencia sonora/visual complementaria para sumergirte en la atmósfera de tu reino.',
    price: 12
  }];
  const bundlePrice = 34.99;
  const toggleAddOn = (id: string) => {
    if (isBundle) return;
    setSelectedAddOns(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const toggleBundle = () => {
    setIsBundle(!isBundle);
    if (!isBundle) {
      setSelectedAddOns([]);
    }
  };
  const calculateTotal = () => {
    if (isBundle) return bundlePrice;
    const addOnTotal = selectedAddOns.reduce((sum, id) => {
      const addOn = addOns.find(a => a.id === id);
      return sum + (addOn?.price || 0);
    }, 0);
    return coreProduct.price + addOnTotal;
  };
  return <section className="relative py-20 px-6 overflow-hidden" data-id="element-111">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-112">
        <img src={PRODUCTOS_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-113" />
        <div className="absolute inset-0 bg-cosmic-black/80" data-id="element-114" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, #050508 0%, rgba(5,5,8,0.5) 50%, #050508 100%)'
      }} data-id="element-115" />
      </div>

      <div className="relative z-10 container mx-auto max-w-6xl" data-id="element-116">
        <AnimatedSection data-id="element-117">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-4" data-id="element-118">
            Desbloquea Tu Reino
          </h2>
          <p className="text-gray-300 text-center mb-16" data-id="element-119">
            Elige tu experiencia
          </p>
        </AnimatedSection>

        {/* Core Product */}
        <AnimatedSection delay={0.2} data-id="element-120">
          <div className="mb-8 max-w-2xl mx-auto" data-id="element-121">
            <div className="bg-cosmic-darker/90 backdrop-blur-sm border-2 border-gold-primary rounded-xl p-8 text-center" style={{
            boxShadow: '0 0 40px rgba(201, 168, 76, 0.3)'
          }} data-id="element-122">
              <h3 className="text-3xl font-serif font-bold text-gold-light mb-4" data-id="element-123">
                {coreProduct.title}
              </h3>
              <p className="text-gray-300 mb-6" data-id="element-124">
                La experiencia fundamental de tu arquetipo
              </p>
              <p className="text-4xl font-bold text-gold-primary mb-6" data-id="element-125">
                ${coreProduct.price}
              </p>
              <p className="text-sm text-gray-400" data-id="element-126">
                Incluido en todas las opciones
              </p>
            </div>
          </div>
        </AnimatedSection>

        {/* Add-ons */}
        <AnimatedSection delay={0.4} data-id="element-127">
          <h3 className="text-2xl font-serif font-semibold text-white text-center mb-8" data-id="element-128">
            Archivos Adicionales
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-129">
            {addOns.map((addOn, index) => <motion.div key={addOn.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.5 + index * 0.1
          }} data-id="element-130">
                <ArtifactCard title={addOn.title} description={addOn.description} price={`+$${addOn.price}`} selected={isBundle || selectedAddOns.includes(addOn.id)} onToggle={() => toggleAddOn(addOn.id)} signColor="#C9A84C" data-id="element-131" />
              </motion.div>)}
          </div>
        </AnimatedSection>

        {/* Bundle */}
        <AnimatedSection delay={0.8} data-id="element-132">
          <div className="max-w-2xl mx-auto mb-12" data-id="element-133">
            <ArtifactCard title="Acceso Completo al Reino" description="Desbloquea el Núcleo del Arquetipo y todos los archivos adicionales en una sola experiencia." price={`$${bundlePrice}`} selected={isBundle} onToggle={toggleBundle} signColor="#E8D48B" isBundle={true} data-id="element-134" />
          </div>
        </AnimatedSection>

        {/* Dynamic Total */}
        <motion.div className="sticky bottom-6 max-w-2xl mx-auto bg-cosmic-black/95 backdrop-blur-sm border-2 border-gold-primary rounded-xl p-6" style={{
        boxShadow: '0 0 40px rgba(201, 168, 76, 0.4)'
      }} initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-135">
          <div className="flex justify-between items-center mb-4" data-id="element-136">
            <div data-id="element-137">
              <p className="text-gray-400 text-sm mb-1" data-id="element-138">Tu selección:</p>
              <p className="text-white font-medium" data-id="element-139">
                {isBundle ? 'Reino Completo' : `Núcleo${selectedAddOns.length > 0 ? ` + ${selectedAddOns.length} archivo${selectedAddOns.length > 1 ? 's' : ''}` : ''}`}
              </p>
            </div>
            <div className="text-right" data-id="element-140">
              <p className="text-gray-400 text-sm mb-1" data-id="element-141">Total:</p>
              <p className="text-3xl font-bold text-gold-light" data-id="element-142">
                ${calculateTotal().toFixed(2)}
              </p>
            </div>
          </div>
          <p className="text-center text-xs text-gold-light/70 italic" data-id="element-143">
            Selecciona tu signo arriba para acceder al checkout de tu reino.
          </p>
        </motion.div>
      </div>
    </section>;
}